import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ParticipantModel } from '../../models/participant.model';
import { AddSignatureModalComponent } from '../add-signature-modal/add-signature-modal.component';
import { SigningType } from '../document-signing.type';
import { SigningOnPdfService } from '../signing-on-pdf/signing-on-pdf.service';
import { SignatureBoxData, SingpassPositionData } from '../signing-on-pdf/signing-on-pdf.type';

@Component({
  selector: 'portal-signing-signature-box',
  templateUrl: './signature-box.component.html',
  styleUrls: ['./signature-box.component.scss'],
})
export class SignatureBoxComponent implements OnInit, OnChanges, OnDestroy {
  constructor(private dialog: MatDialog, private signingOnPdfService: SigningOnPdfService, private elementRef: ElementRef) {}

  @Input() currentSession!: string;
  @Input() accessToken!: string;
  @Input() singpassPositions: Array<SingpassPositionData> = [];
  @Input() position!: { 'top.px': any; 'left.px': any };
  @Input() scale = 1;
  @Input() info!: ParticipantModel;
  @Input() signingTypes: SigningType[] = ['drawSignature'];
  @Output() completed = new EventEmitter<SignatureBoxData>();
  @ViewChild('signatureEl', { static: false }) signatureEl!: ElementRef;
  isLocked = true;
  isSigned = false;
  signatureData!: SignatureBoxData;
  unsubscribeAll: Subject<void> = new Subject<void>();
  defaultStyle = {
    'width.px': AddSignatureModalComponent.defaultSignatureSize.width,
    'height.px': AddSignatureModalComponent.defaultSignatureSize.height,
  };
  style: any = { ...this.defaultStyle };
  singpassMode = false;

  afterFitText = new Subject<void>();

  @HostListener('click', ['$event'])
  private onClick($event: Event): void {
    if (!this.isLocked) {
      this.openSignaturePadDialog();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // resize signature box
    if (changes['signingTypes']) {
      if (this.signingTypes.includes('singpass')) {
        this.singpassMode = true;
        this.defaultStyle['width.px'] = AddSignatureModalComponent.defaultSignatureSize.singpassWidth;
        this.defaultStyle['height.px'] = AddSignatureModalComponent.defaultSignatureSize.singpassHeight;
      } else {
        this.singpassMode = false;
      }
    }
    if (changes['scale'] || changes['position']) {
      this.style['width.px'] = this.defaultStyle['width.px'] * this.scale + 4;
      // this.style['height.px'] = this.defaultStyle['height.px'] * this.scale + 4;
      this.style['height.px'] = this.defaultStyle['height.px'] * this.scale + 10;
      this.style = {
        ...this.style,
        // 'top.px': this.position['top.px'] - 3,
        'top.px': this.position['top.px'] - 5,
        'left.px': this.position['left.px'] - 3,
      };
    }
    this.isLocked = this.currentSession !== this.info.markupId;
  }

  ngOnInit(): void {
    // broadcast singpass signature
    this.signingOnPdfService.singpassData
      .pipe(
        // filter(v => v),
        takeUntil(this.unsubscribeAll),
      )
      .subscribe(data => {
        if (data && data[this.accessToken] && !this.isLocked) {
          this.signed(data[this.accessToken]);
        }
      });

    this.afterFitText.pipe(takeUntil(this.unsubscribeAll)).subscribe(() => {
      // setTimeout(() => {
      // htmlToImage.toPng(this.signatureEl.nativeElement.querySelector('.signature-singpass-v2')).then(data => {
      //     console.log('hello',data);
      //     this.data.value.finalValue = data;
      // });

      this.signatureData.signature = this.signatureEl.nativeElement.innerHTML;
      this.isSigned = true;
      this.completed.emit(this.signatureData);
      // },1000);
    });
  }

  openSignaturePadDialog() {
    const dialogRef = this.dialog.open(AddSignatureModalComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'signature-modal',
      data: {
        singpassPositions: this.singpassPositions,
        signingTypes: this.signingTypes,
        token: this.accessToken,
        info: this.info,
      },
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe(result => {
        if (result) {
          this.signed(result);
        }
      });
  }

  async signed(result: any) {
    this.signatureData = {
      signature: result.signatureData,
    };
    if (this.singpassMode) {
      this.fitText();
    } else {
      this.isSigned = true;
      this.completed.emit(this.signatureData);
    }
    // await this.loadSignatureImage();
  }

  fitText(fontStart = 16) {
    setTimeout(() => {
      const el = this.signatureEl.nativeElement.querySelector('.signature-singpass-v2');
      const child = el.querySelector('.singpass-data-name');
      const container = child.querySelector('.singpass-data-name__container');
      child.style.fontSize = `${fontStart}px`;

      const textContainerHeight = container.offsetHeight;
      const maxHeight = child.offsetHeight;
      if (textContainerHeight > maxHeight) {
        // shrink font size
        const ratioHeight = Math.floor(textContainerHeight / maxHeight);
        fontStart -= ratioHeight;
        this.fitText(fontStart);
      } else {
        this.afterFitText.next();
      }
    }, 0);
  }

  // async loadSignatureImage() {
  //     console.log('loadSignatureImage');
  //     return new Promise((resolve, reject) => {
  //         setTimeout(async () => {
  //             try {
  //                 this.signatureData.signatureImage = await htmlToImage.toPng(this.signatureEl.nativeElement as HTMLElement);
  //                 resolve();
  //             } catch (e) {
  //                 reject(e);
  //             }
  //         });
  //     });
  // }

  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
